import { AvatarModule } from 'primeng/avatar';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { SplitterModule } from 'primeng/splitter';
import { DialogModule } from 'primeng/dialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';

import { NgxPermissionsModule } from 'ngx-permissions';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';

const CommonModulesList: any[] = [
  AvatarModule,
  NgScrollbarModule,
  SplitterModule,
  DialogModule,
  NgSelectModule,
  CKEditorModule,
  ButtonModule,
  CheckboxModule,
  AutoCompleteModule,
  TooltipModule,
  OverlayPanelModule,
  DragDropModule,
  RadioButtonModule,
  CalendarModule,
  InputMaskModule,
  TableModule,
  PaginatorModule,
  NgxPermissionsModule,
  ConfirmPopupModule,
  ChipModule,
  ChipsModule,
  PipeDirectiveModule,
];
@NgModule({
  declarations: [],
  imports: [...CommonModulesList],
  exports: [...CommonModulesList],
})
export class ContactPrimeNgModule {}
